import type { Topic } from "~/lqs";
import type { PanelNode } from "./api";
import { VisualizationType } from "./constants";

const IMAGE_TOPICS = [
  "sensor_msgs/Image",
  "sensor_msgs/CompressedImage",
  "stereo_msgs/DisparityImage",
  "sensor_msgs/msg/Image",
  "sensor_msgs/msg/CompressedImage",
  "stereo_msgs/msg/DisparityImage",
  "logqs.inference.depth-estimation",
  "logqs.inference.image-segmentation",
  "logqs.inference.image-to-image",
  "ark::image::Image",
];

const THREE_D_TOPICS = [
  "sensor_msgs/PointCloud2",
  "sensor_msgs/msg/PointCloud2",
];

const MAP_TOPICS = ["sensor_msgs/NavSatFix", "sensor_msgs/msg/NavSatFix"];

export function getSupportedVisualizations(
  panel: PanelNode,
): Record<VisualizationType, boolean> {
  const defaultVisualization =
    panel.isInitialized && getDefaultVisualization(panel.topicTypeName);

  return {
    [VisualizationType.Image]: defaultVisualization === VisualizationType.Image,
    [VisualizationType.ThreeD]:
      defaultVisualization === VisualizationType.ThreeD,
    [VisualizationType.Map]: defaultVisualization === VisualizationType.Map,
    [VisualizationType.Chart]: panel.isInitialized && panel.fields.length > 0,
    [VisualizationType.Timeline]: true,
  };
}

export function getDefaultVisualization(
  typeName: Topic["typeName"],
): VisualizationType {
  switch (true) {
    case IMAGE_TOPICS.includes(typeName!): {
      return VisualizationType.Image;
    }
    case THREE_D_TOPICS.includes(typeName!): {
      return VisualizationType.ThreeD;
    }
    case MAP_TOPICS.includes(typeName!): {
      return VisualizationType.Map;
    }
    default: {
      return VisualizationType.Timeline;
    }
  }
}
